import { RootState } from 'src/store';
import { getUserOptions } from './queries';
import type { Note } from './types';

const sortNotesByCreatedDate = (notes: Note[] = []) =>
  [...notes].sort(
    (firstNote, secondNote) =>
      new Date(secondNote.created_date).getTime() -
      new Date(firstNote.created_date).getTime(),
  );

export const getLoading = (state: RootState) => state?.notes?.loading;

export const getError = (state: RootState) => state?.notes?.error;

export const getThreadLoading = (state: RootState, parentKey: string) =>
  state?.notes?.threadLoading[parentKey];

export const getThreadError = (state: RootState, parentKey: string) =>
  state?.notes?.threadError[parentKey];

export const getNotes = (state: RootState) =>
  sortNotesByCreatedDate(state?.notes?.notes);

export const getThreadNotes = (state: RootState, parentKey: string) =>
  sortNotesByCreatedDate(state?.notes?.threadNotes[parentKey]);

export const getUsers = (state: RootState) => getUserOptions(state.notes.users);

export const getIsMoreLoading = (state: RootState) => state.notes.loadingMore;

export const getIsMoreLoadingError = (state: RootState) =>
  state.notes.loadMoreError;

export const getIsParentEditorActive = (state: RootState) =>
  Boolean(state.notes.isParentEditorActive);
